export const checkAvenir = program => {
  if (program?.perimeter === 'AVENIR') {
    return true;
  }
  return false;
};
